import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <p>@OSM-Trip 2021</p>
    </footer>
  );
};

export default Footer;
